import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icons/logout-red.png'


const _hoisted_1 = {
  id: "header",
  class: "header-area style-two bg-white w-100"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-xl-6 col-lg-5 col-md-5 col-sm-4" }
const _hoisted_5 = { class: "header-left d-flex align-items-center" }
const _hoisted_6 = { class: "col-xl-6 col-lg-7 col-md-7 col-sm-8" }
const _hoisted_7 = { class: "header-right d-flex align-items-center justify-content-sm-end justify-content-between" }
const _hoisted_8 = { class: "option-item" }
const _hoisted_9 = { class: "option-item" }
const _hoisted_10 = { class: "option-item" }
const _hoisted_11 = { class: "option-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ToggleFullscreenBtn = _resolveComponent("ToggleFullscreenBtn")!
  const _component_ProfileDropdown = _resolveComponent("ProfileDropdown")!
  const _component_SettingsBarBtn = _resolveComponent("SettingsBarBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "logo",
              style: {"color":"#B18164","text-transform":"uppercase","font-weight":"bold","text-decoration":"none"}
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" AURABÊ ")
              ])),
              _: 1,
              __: [4]
            }),
            _createElementVNode("button", {
              class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
              id: "header-burger-menu",
              title: "Hide/Show",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleBurgerMenu && _ctx.toggleBurgerMenu(...args)))
            }, [
              _withDirectives(_createElementVNode("i", {
                class: "menu ri-menu-line",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleButtonVisibility('openBtn')))
              }, null, 512), [
                [_vShow, _ctx.showOpenBtn]
              ]),
              _withDirectives(_createElementVNode("i", {
                class: "close ri-close-line",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleButtonVisibility('closeBtn')))
              }, null, 512), [
                [_vShow, _ctx.showCloseBtn]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ToggleFullscreenBtn)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ProfileDropdown)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_SettingsBarBtn)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", {
                class: "nav-link",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Logout"
                }, null, -1)
              ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}